import { NgModule } from '@angular/core';

import { PriceBaseService } from './price-base.service';
import { PriceService } from './price.service';
import { PriceDictionaryService } from './price-dictionary.service';

@NgModule({
    imports: [],
    exports: [],
    declarations: [],
    providers: [
        PriceService,
        PriceBaseService,
        PriceDictionaryService
    ],
})
export class PriceModule {}
